import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ConteudosComponent } from './conteudos/conteudos.component';
import { PerdaDocumentosComponent } from './conteudos/perda-documentos/perda-documentos.component';
import { ExperienciaClienteComponent } from './conteudos/experiencia-cliente/experiencia-cliente.component';
import { SolucaoComponent } from './solucao/solucao.component';
import { PoliticaPrivacidadeComponent } from './politica-privacidade/politica-privacidade.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'solucao', component: SolucaoComponent },
  { path: 'conteudos', component: ConteudosComponent },
  { path: 'conteudos/extermine-a-perda-de-documentos', component: PerdaDocumentosComponent },
  { path: 'conteudos/experiencia-do-cliente-em-escritorios-contabeis', component: ExperienciaClienteComponent },
  { path: 'politica-privacidade', component: PoliticaPrivacidadeComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', anchorScrolling: 'enabled', scrollOffset: [0, 80] })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
